import styled from "styled-components";
import SampleCloseButton from "../../question-sample/styles/SampleCloseButton.styled";

export const DesktopDocSample = styled.div`
  display: flex;
  padding: 24px;
  width: 100%;
  margin: 0 -24px 0 -24px;
  background-color: ${({ theme }) => theme.colors.base2};

  section {
    display: flex;
    align-items: flex-start;
    padding: 24px;
    width: 100%;
    background-color: ${({ theme }) => theme.colors.baseWhite};
    flex-direction: column;
    gap: 16px;
    box-sizing: border-box;
  }

  img {
    display: inline-block;
    max-height: 320px;
    flex: 0;
  }

  .doc-sample-header {
    display: flex;
    align-items: flex-start;
    width: 100%;
    justify-content: space-between;
  }

  ${SampleCloseButton} img {
    height: 24px;
  }

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export const MobileDocSample = styled.div`
  display: none;
  padding: 24px;
  background-color: ${({ theme }) => theme.colors.base2};
  box-sizing: border-box;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: block;
    width: 100%;

    section {
      display: flex;
      align-items: flex-start;
      padding: 24px;
      width: 100%;
      background-color: ${({ theme }) => theme.colors.baseWhite};
      flex-direction: column;
      gap: 16px;
      box-sizing: border-box;
    }

    img {
      display: inline-block;
      width: 100%;
      flex: 0;
    }

    .doc-sample-header {
      display: flex;
      width: 100%;
      justify-content: space-between;
    }

    ${SampleCloseButton} img {
      height: 24px;
    }
  }
`;
